module.exports = __webpack_public_path__ + "static/media/gesture-manina.bd563b0a.svg";